import React from 'react';
import PropTypes from 'prop-types';

// import TableContainer from '@material-ui/core/TableContainer';
import Container from '@material-ui/core/Container';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
// import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const PreferenceExpandedItem = (props) => {
  const attr = Array.isArray(props.attributes) ? props.attributes: [];
  return (
    <Container style={{  backgroundColor: '#f4f6f8' }}>
      {
        attr.length
          ? (
            <Table>
              <TableHead>
                <TableRow>
                  {
                    ['Name', 'Value', 'Description', 'Override'].map((txt, idx) => {
                      return (
                        <TableCell key={idx} align='center' style={{ padding: 8 }}>{txt}</TableCell>
                      )
                    })
                  }
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  attr.map(({ name, value, description, override }, idx) => {
                    return (
                      <TableRow key={idx}>
                        <TableCell align='center' style={{ padding: 8 }}>{name}</TableCell>
                        <TableCell align='center' style={{ padding: 8 }}>{value || '-'}</TableCell>
                        <TableCell align='center' style={{ padding: 8 }}>{description || '-'}</TableCell>
                        <TableCell align='center' style={{ padding: 8 }}>{override === true ? 'True' : 'False'}</TableCell>
                      </TableRow>
                    );
                  })
                }
              </TableBody>
            </Table>
          )
          : (<Typography align='center'>There are no attributes</Typography>)
      }
    </Container>
  );
};

PreferenceExpandedItem.propTypes = {
  attributes: PropTypes.array.isRequired
};

export default React.memo(PreferenceExpandedItem);